module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8011.c0190b89.png";